import type { FC } from "react";
import { useTranslation } from "react-i18next";
import { HiArrowLeft } from "react-icons/hi";
import { Button } from "@components";
import { PageHeader } from "@design-system";

export interface AllOrdersPageHeaderProps {
  splitIsOpen: boolean;
  fromPath?: string;
  onGoBack: () => void;
}

/** Title/description header (with optional back button) for the All Orders page. */
export const AllOrdersPageHeader: FC<AllOrdersPageHeaderProps> = ({
  splitIsOpen,
  fromPath,
  onGoBack,
}) => {
  const { t } = useTranslation(["common", "orders"]);

  return (
    <PageHeader
      hiddenWhenSplit
      splitIsOpen={splitIsOpen}
      leading={
        fromPath ? (
          <Button color="light" onClick={onGoBack} className="mb-2">
            <HiArrowLeft className="mr-2 h-5 w-5" />
            {t("common:back")}
          </Button>
        ) : undefined
      }
      title={t("orders:all_orders.page_title")}
      description={t("orders:all_orders.page_description")}
    />
  );
};
